@if (item$ | async; as item) {

    <div class="text_content">
        <p>
            <strong>{{ 'distributor.name.value' | translate }}</strong> : {{ item.society.name }}
        </p>

        <p>
            <strong>{{ 'distributor.website.value' | translate }}</strong> :
            @if (item.society.mainWebsite; as website) {
                <a href="{{ website | externalUrl }}" target="_blank" class="link_text">{{ website }}</a>
            }
        </p>

        <p>
            <strong>{{ 'distributor.address.value' | translate }}</strong> : {{ getAddressFields(item).address }}, {{ getAddressFields(item).zipcode }} {{ getAddressFields(item).city }}
        </p>

        <p>
            <strong>{{ 'distributor.country.value' | translate }}</strong> : {{ getAddressFields(item).country }}
        </p>

        @if (!!item.society.admin) {
            <p>
                <strong>{{ 'distributor.type.value' | translate }}</strong> : {{ getRoleLabel(item.society.admin.roles) }}
            </p>
            @if (hasOneOfThisRoles(['ROLE_FEDERATION', 'ROLE_INSTITUTIONAL'], item.society.admin)) {
                <span class="message-help">
                    <mat-icon class="tooltip_icon">info</mat-icon>
                    {{ 'distributor.type.info.value' | translate }}
                </span>
            }
        }

    </div>
}
